export function rosterPanelHtml(): string {
  return `
    <div class="raid-roster-panel">
      <p class="raid-roster-hint" data-hint></p>
      <details class="raid-roster-help" data-help>
        <summary class="raid-roster-help-sum" data-help-sum></summary>
        <div class="raid-roster-help-body" data-help-body></div>
      </details>
      <p class="raid-roster-count" data-count></p>
      <p class="raid-roster-classes" data-classes></p>
      <div class="raid-roster-pool" data-pool></div>
      <p class="raid-roster-msg" data-msg></p>
      <div class="raid-roster-start" data-start>
        <span class="raid-roster-start-lab" data-start-lab></span>
        <div class="raid-roster-start-btns">
          <button type="button" class="menu-btn" data-start-assault></button>
          <button type="button" class="menu-btn" data-start-boss></button>
        </div>
      </div>
      <div class="raid-roster-actions">
        <button type="button" class="menu-btn" data-confirm></button>
        <button type="button" class="menu-btn" data-back></button>
      </div>
    </div>
  `;
}

/** Compact hero card — combat kit / disposition / engagement / gambits / traits. */
export function rosterCardHtml(): string {
  return `
    <button type="button" class="raid-roster-card" data-card>
      <div class="raid-roster-card-head">
        <span class="raid-roster-card-name" data-name></span>
        <span class="raid-roster-card-class" data-class></span>
      </div>
      <div class="raid-roster-card-tags">
        <span class="raid-roster-quirk" data-quirk></span>
        <span class="raid-roster-eng" data-engage></span>
        <span class="raid-roster-dom" data-dominant></span>
        <span class="raid-roster-exp" data-experimental hidden></span>
      </div>
      <div class="raid-roster-combat" data-combat></div>
      <div class="raid-roster-axes" data-axes></div>
      <div class="raid-roster-gambits" data-gambits></div>
      <div class="raid-roster-traits" data-traits></div>
    </button>
  `;
}
